import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import DeletesToast from '@/components/toasts/DeletesToast';
import {
  createUsergroupActions,
  updateUsergroupActions,
  usergroupUsersActions,
  userUsergroupsActions,
  deleteUsergroupActions,
} from '../constants';
import UserGroupCreatedToast from '../components/UserGroupCreatedToast';
import UserGroupsAssignErrorToast from '../components/UserGroupsAssignErrorToast';
import UsergroupUsersAddErrorToast from '../components/UsergroupUsersAddErrorToast';
import UsergroupUsersAddSuccessToast from '../components/UsergroupUsersAddSuccessToast';
import UsergroupRemoveErrorToast from '../components/UsergroupRemoveErrorToast';
import UsergroupRemoveSuccessToast from '../components/UsergroupRemoveSuccessToast';
import UsersGroupsAddSuccessToast from '../components/UsersGroupsAddSuccessToast';
import UsersGroupsRemoveSuccessToast from '../components/UsersGroupsRemoveSuccessToast';

export function* deleteUserGroupErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.delete" errors={items} />);
}

export function* createUserGroupToast({ result }) {
  yield call(showToast, <UserGroupCreatedToast code={result.code} name={result.name} />);
}

export function* deleteUserGroupToast({ items }) {
  yield call(showToast, <DeletesToast items={items} />);
}

export function* updateUserGroupToast({ result }) {
  yield call(showToast, <UpdatedToast code={result.code} name={result.name} />);
}

export function* addUsersGroupsErrorToast({ user, groups }) {
  yield call(showToast, <UserGroupsAssignErrorToast users={[user]} groups={groups} />);
}

export function* addUsersToGroupErrorToast({ errors, group }) {
  yield call(showToast, <UsergroupUsersAddErrorToast users={errors} group={group} />);
}

export function* addUsersToGroupSuccessToast({ results, group }) {
  yield call(showToast, <UsergroupUsersAddSuccessToast users={results} group={group} />);
}

export function* removeUserFromGroupErrorToast({ user, group }) {
  yield call(showToast, <UsergroupRemoveErrorToast group={group} user={user} />);
}

export function* removeUserFromGroupSuccessToast({ user, group }) {
  yield call(showToast, <UsergroupRemoveSuccessToast group={group} user={user} />);
}

export function* addGroupsToUserSuccessToast({ groups }) {
  yield call(showToast, <UsersGroupsAddSuccessToast groups={groups} />);
}

export function* removeGroupFromUserErrorToast({ group, error }) {
  yield call(showToast, <ErrorsToast operation="actions.delete" errors={[{ ...group, error }]} />);
}

export function* removeGroupFromUserSuccessToast({ group }) {
  yield call(showToast, <UsersGroupsRemoveSuccessToast groups={[group]} />);
}

export default function* userGroupsToasts() {
  yield takeEvery(createUsergroupActions.CREATE_USERGROUP_SUCCESS, createUserGroupToast);
  yield takeEvery(deleteUsergroupActions.DELETE_USERGROUP_ERROR, deleteUserGroupErrorToast);
  yield takeEvery(deleteUsergroupActions.DELETE_USERGROUP_SUCCESS, deleteUserGroupToast);
  yield takeEvery(updateUsergroupActions.UPDATE_USERGROUP_SUCCESS, updateUserGroupToast);
  yield takeEvery(userUsergroupsActions.ADD_USERS_GROUPS_ERROR, addUsersGroupsErrorToast);
  yield takeEvery(usergroupUsersActions.ADD_USERGROUP_USERS_ERROR, addUsersToGroupErrorToast);
  yield takeEvery(usergroupUsersActions.ADD_USERGROUP_USERS_SUCCESS, addUsersToGroupSuccessToast);
  yield takeEvery(usergroupUsersActions.REMOVE_USERGROUP_USER_ERROR, removeUserFromGroupErrorToast);
  yield takeEvery(usergroupUsersActions.REMOVE_USERGROUP_USER_SUCCESS, removeUserFromGroupSuccessToast);
  yield takeEvery(userUsergroupsActions.ADD_USERS_GROUPS_SUCCESS, addGroupsToUserSuccessToast);
  yield takeEvery(userUsergroupsActions.REMOVE_USERS_GROUP_ERROR, removeGroupFromUserErrorToast);
  yield takeEvery(userUsergroupsActions.REMOVE_USERS_GROUP_SUCCESS, removeGroupFromUserSuccessToast);
}
